export default "__VITE_ASSET__Bbn3yerp__"